import React from 'react';
import { Zap, Building, Users, Briefcase, CheckCircle } from 'lucide-react';

const Industries = () => {
  const industries = [
    {
      icon: Zap,
      title: "Startups",
      description: "Product development and MVP creation for emerging companies",
      services: ["MVP Development", "Prototype Design", "Market Validation", "Scaling Solutions"]
    },
    {
      icon: Building,
      title: "SMEs & Enterprises",
      description: "Digital transformation for small to medium enterprises",
      services: ["System Integration", "Process Automation", "Legacy Modernization", "Performance Optimization"]
    },
    {
      icon: Users,
      title: "Agencies",
      description: "Reliable development teams for creative and marketing agencies",
      services: ["White-label Solutions", "Custom Development", "Technical Consultation", "Project Management"]
    },
    {
      icon: Briefcase,
      title: "Traditional Businesses",
      description: "Digital transformation for established traditional companies",
      services: ["Digital Strategy", "E-commerce Solutions", "Customer Portals", "Data Analytics"]
    }
  ];

  return (
    <section id="industries" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">Industries We Serve</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From startups to enterprises, we provide tailored solutions for every business type
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {industries.map((industry, index) => (
            <div key={index} className="text-center group">
              <div className="bg-gradient-to-r from-cyan-400 to-blue-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <industry.icon className="w-10 h-10 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{industry.title}</h3>
              <p className="text-gray-600 mb-4">{industry.description}</p>
              <div className="space-y-2">
                {industry.services.map((service, serviceIndex) => (
                  <div key={serviceIndex} className="flex items-center justify-center">
                    <CheckCircle className="w-4 h-4 text-cyan-500 mr-2" />
                    <span className="text-sm text-gray-600">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;